export default "__VITE_ASSET__Rc2Mh7zM__"